'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpDiffusionConnector = require('rp-diffusion-connector');

var _rpDiffusionConnector2 = _interopRequireDefault(_rpDiffusionConnector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RdlDiffusion = function RdlDiffusion($, options) {

    var config = $.extend({
        topicName: '',
        callbackLE: function callbackLE() {}
    }, options);

    var sessionConfig = {
        onCallbackFunction: function onCallbackFunction() {},
        onDataFunction: onDataReceive
    };

    var session = new _rpDiffusionConnector2.default(sessionConfig);

    session.subscribe({ topic: config.topicName });

    function onDataReceive(WebClientMessage) {
        if (WebClientMessage.topic === 'LIVE_EVENT/1') {
            config.callbackLE(WebClientMessage.records[0].fields[0], WebClientMessage.records[0].fields[1]);
        }
    }

    return session;
};

exports.default = RdlDiffusion;


//////////////////
// WEBPACK FOOTER
// ./~/rp-race-day-live/lib/js/diffusion.js
// module id = 1529
// module chunks = 1